// extracted by mini-css-extract-plugin
export default {"content":"LegalPage_content__w5XH7","bold":"LegalPage_bold__u3nr7"};